import { defineComponent, reactive, onMounted } from '@vue/composition-api';
import axios from 'axios';
import { SettingsContext } from '@/utilities/settings-context';
import { CompanyInfo } from '@/views/company-info/company-info-types';
import AdminCompanyInvoice from '@/components/admin-company-invoice/admin-company-invoice.vue';
import moment from 'moment';
import { getDefaultPreferences } from '@/functions/global-functions';
import {copyText} from "@/utilities/copy";
import { alertDialogue } from '@/functions/system-modal-functions';
import { i18n } from '@/utilities/vue-i18n';
import { BillingProfileInfo } from './admin-company-overview-types';

export default defineComponent({
	components: {
		AdminCompanyInvoice
	},
  setup(_, context) {

	const props = reactive({
		company: context.root.$route.params.company,
	});

    const model = reactive({ 
      company: {} as CompanyInfo,
      billingProfile: null as BillingProfileInfo | null,
      mediaSelectionUpdatedAtDisplay: null as string | null,
      token: null as string | null,
      downloading: false,
      copied: false,
      copyLink: '',
    });

    const getUploadToken = async () => {
      const response = await axios.post(SettingsContext.getApiUrl('getSoMeUploadMediaTokenForCompany') + `/${props.company}`);

      model.token = response.data;
    };

    const getCompany = async (id: string) => {

      const response = await axios.get(SettingsContext.getApiUrl('getCompany'), {params: {id: parseInt(id)}});

      model.company = response.data;

      model.mediaSelectionUpdatedAtDisplay = model.company.mediaSelectionUpdatedAt ? moment(model.company.mediaSelectionUpdatedAt).format(getDefaultPreferences().format) : null;

      getUploadToken();
    };

    const getBillingProfile = async (id: string) => {
      const invoiceParam = context.root.$route.params.invoice;
      const invoiceId = invoiceParam ? parseInt(`${invoiceParam}`) : null;

      const response = await axios.get<BillingProfileInfo>(SettingsContext.getApiUrl('GetBillingProfile'), {
        params: {
          companyId: parseInt(id),
          invoiceId,
        }
      });

      model.billingProfile = response.data;
    };

    const downloadMedia = async () => {
      if(model.downloading) {
        return;
      }

      model.downloading = true;

      const response = await axios.get(SettingsContext.getApiUrl('downloadMediaFile') + `/${props.company}`, {responseType: 'blob'});

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('target', '_blank');
      link.style.opacity = '0';
      link.setAttribute('download', `media-${props.company}.zip`);

      document.body.appendChild(link);

      link.click();

      link.remove();
      model.downloading = false;
    };

    const copyDownloadLink = async () => {
      if(!model.token) {
        return;
      }
      
      model.copyLink = '',
      model.copied = false;
      
      if(await copyText(`https://some.ledigajobb.se/${props.company}/${encodeURIComponent(model.token)}`)) {
        model.copied = true;

        setTimeout(() => {
          model.copied = false;
        }, 4000);  
      }
      else {
        alertDialogue(i18n.t('media.failed-to-copy-link'), i18n.t('media.failed-to-copy-link-message'));
        model.copyLink = `https://some.ledigajobb.se/${props.company}/${encodeURIComponent(model.token)}`;
      }
    };

    onMounted(() => {

      if (props.company) {

        getCompany(props.company);

        getBillingProfile(props.company);
      }
    });

    return {

      model,

      props,

      copyDownloadLink,

      downloadMedia,
    };
  }
})